<template>
  <div class="login-main">
    <form class="login-card" @submit.prevent="login">
      <div class="login-card-title">
         イベント管理システム
      </div>
      <div class="login-input">
        <input
          type="text"
          class="input-text"
          placeholder="ログインID（メール）"
          v-model="loginId">
      </div>

      <div class="login-input">
        <input
          type="password"
          class="input-text"
          placeholder="パスワード"
          v-model="password">
      </div>

      <button
        type="submit"
        class="login-button"
        :class="styleDisable()">
        ログイン
      </button>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loginId: '',
      password: ''
    }
  },
  methods: {
    login: function () {
      if (this.loginId === '' || this.password === '') {
        return
      }
      this.$store.getters.Parse.User.logIn(this.loginId, this.password)
        .then(() => {
          this.$router.push('/')
        })
        .catch((error) => {
          this.$store.commit(
            'snackBar/addMessage',
            this.$store.getters['error/status'](error.code)
          )
        })
    },
    styleDisable: function () {
      if (this.loginId === '' || this.password === '') {
        return { 'disable': true }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $peter-liver;
}

.login-card {
  width: 450px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 4px;

  &-title {
    font-size: 1.5em;
    font-weight: bold;
    padding-bottom: 20px;
    color: $wet-asphalt;
  }
}

.login-input {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 10px;
}

.input-text {
  @include input-reset-design;
  padding: 10px;
  border-radius: 4px;
  height: 30px;
  width: 70%;
  background: $clouds;
  font-size: 1.2em;
}

.login-button {
  @include input-reset-design;
  margin: 10px;
  padding: 10px;
  width: 75%;
  border-radius: 4px;
  font-size: 1.2em;
  background: $peter-liver;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.disable {
  background: $concrete;
  cursor: default;
}
</style>
